import { render, staticRenderFns } from "./TaskStatistic.vue?vue&type=template&id=aef48ee8&scoped=true"
import script from "./TaskStatistic.vue?vue&type=script&lang=js"
export * from "./TaskStatistic.vue?vue&type=script&lang=js"
import style0 from "./TaskStatistic.vue?vue&type=style&index=0&id=aef48ee8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef48ee8",
  null
  
)

export default component.exports